import type { AppLifecycleState, Platform } from "./Platform";

/** The only place `document.visibilitychange` is touched — everything else sees the typed event. */
export class WebPlatform implements Platform {
  onLifecycleChange(listener: (state: AppLifecycleState) => void): () => void {
    const handler = () => listener(document.hidden ? "background" : "foreground");
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }
}
